import React, { useEffect, useState } from "react";
import "./cricket.scss";

const Cricket = () => {
  useEffect(() => {
    const fetchdata = () => {
      fetch(
        `${process.env.REACT_APP_API_CRICKET}/livescores?api_token=${process.env.REACT_APP_API_TOKEN}&include=runs`,
        {
          method: "GET",
          headers: {
            Accept: "application/json",
          },
        }
      )
        .then((res) => {
          return res.json();
        })
        .catch((err) => {
          console.log(err);
        })
        .then((data) => {
          console.log(data);
        });
    };
    fetchdata();
  }, []);

  return (
    <div>
      <div className="container">
        <div className="card mt-2">
          <div className="card-body">
            <h2 className="text-center font-weight-bold text-muted">
              <img src="https://img.icons8.com/emoji/45/000000/cricket-game-emoji.png" />
              Cricket
            </h2>
          </div>
        </div>
        {/* Live cricket score */}
        <div className="card mt-2 ">
          <div className="card-header">
            <h6 className="mt-3 ">
              {" "}
              <span className="bg-danger text-white pl-1 pr-1 pb-1 rounded">
                <i className="fas fa-circle round-logo animate__animated animate__flash"></i>{" "}
                Live
              </span>{" "}
              <span className="font-weight-bold">LIVE CRICKET SCORE</span>
            </h6>
          </div>
          <div className="card-body"></div>
        </div>
      </div>
    </div>
  );
};

export default Cricket;
